import { ServiceQueueSpecialist } from '@/service/specialists/serviceQueueSpecialist'

const serviceQueueSpecialist = new ServiceQueueSpecialist()

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    checkPermission() {
      return new Promise((resolve, reject) => {
        serviceQueueSpecialist.checkPermission()
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    setGroup() {
      return new Promise((resolve, reject) => {
        serviceQueueSpecialist.setGroup()
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    fetchPacientes() {
      return new Promise((resolve, reject) => {
        serviceQueueSpecialist.listQueue()
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    updateQueue({ commit }, payload) {
      return new Promise((resolve, reject) => {
        serviceQueueSpecialist.updateQueue(payload)
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
  },
  getters: {},
}
